import { useGetPlayerEventsV1McQuery } from "../../../core/api/mc-player-events-api"
import PlayerEventsDialog from "../common/PlayerEventsDialog"
import PlayerEventsPage from "../common/PlayerEventsPage"
import { initialQuickLookSettings } from "./McPlayerEventsConstants"

const PlayerEvents = () => (
    <PlayerEventsPage
        useQuery={useGetPlayerEventsV1McQuery}
        storageKey="mc_quick_look_settings"
        initialSettings={initialQuickLookSettings}
        typeField="eventType"
        typeHeaderName="Event Type"
        DialogComponent={PlayerEventsDialog}
    />
)

export default PlayerEvents
